module.exports = __webpack_public_path__ + "img/icon_send_off.79003627.svg";